// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackButton_container__yqldg {
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    column-gap: 9.5px;
    border-radius: 25px;
    background-color: var(--primary-light);
    padding: 15px 14px;
    transition: all 0.3s ease-out;
}

.BackButton_container__yqldg * {
    transition: all 0.3s ease-out;
}

.BackButton_container__yqldg:not(.BackButton_hovered__j3wZj):hover {
    background-color: var(--primary-dark);
}

.BackButton_container__yqldg:not(.BackButton_hovered__j3wZj):hover * {
    color: var(--primary-light);
}

.BackButton_hovered__j3wZj svg {
    transform: rotate(-90deg);
}

.BackButton_container__yqldg svg path {
    stroke: var(--primary-accent);
}

.BackButton_text__3RGiu {
    font-size: var(--font-size-6);
    color: var(--primary-dark);
    font-family: var(--font-medium), sans-serif;
    margin-top: 2px;
    transition: color 0.3s ease-out;
    white-space: nowrap;
}

.BackButton_listContainer__fq6w3 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 2px;
    background-color: var(--primary-light);
    border-radius: 12px;
    padding: 16px;
    transition: all 0.3s ease-out;
    position: absolute;
    top: 3.25vw;
    left: 0;
    width: 200px;
    height: auto;
    z-index: 10000;
}

@media screen and (min-width: 1023px) and (max-width: 1400px) {
    .BackButton_listContainer__fq6w3 {
        top: 5vw;
    }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
    .BackButton_listContainer__fq6w3 {
        top: 7vw;
    }
}

.BackButton_listTitle__7hEw7 {
    font-size: var(--font-size-6);
    font-family: var(--font-medium), sans-serif;
    color: var(--primary-dark-02);
    margin-bottom: 8px;
    margin-left: 8px;
    pointer-events: none;
}

.BackButton_listElement__PYBjy {
    padding: 8px;
    font-family: var(--font-medium), sans-serif;
    width: 100%;
    border-radius: 8px;
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/BackButton/BackButton.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,2CAA2C;IAC3C,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,6BAA6B;IAC7B,2CAA2C;IAC3C,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,2CAA2C;IAC3C,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".container {\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    column-gap: 9.5px;\n    border-radius: 25px;\n    background-color: var(--primary-light);\n    padding: 15px 14px;\n    transition: all 0.3s ease-out;\n}\n\n.container * {\n    transition: all 0.3s ease-out;\n}\n\n.container:not(.hovered):hover {\n    background-color: var(--primary-dark);\n}\n\n.container:not(.hovered):hover * {\n    color: var(--primary-light);\n}\n\n.hovered svg {\n    transform: rotate(-90deg);\n}\n\n.container svg path {\n    stroke: var(--primary-accent);\n}\n\n.text {\n    font-size: var(--font-size-6);\n    color: var(--primary-dark);\n    font-family: var(--font-medium), sans-serif;\n    margin-top: 2px;\n    transition: color 0.3s ease-out;\n    white-space: nowrap;\n}\n\n.listContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    row-gap: 2px;\n    background-color: var(--primary-light);\n    border-radius: 12px;\n    padding: 16px;\n    transition: all 0.3s ease-out;\n    position: absolute;\n    top: 3.25vw;\n    left: 0;\n    width: 200px;\n    height: auto;\n    z-index: 10000;\n}\n\n@media screen and (min-width: 1023px) and (max-width: 1400px) {\n    .listContainer {\n        top: 5vw;\n    }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n    .listContainer {\n        top: 7vw;\n    }\n}\n\n.listTitle {\n    font-size: var(--font-size-6);\n    font-family: var(--font-medium), sans-serif;\n    color: var(--primary-dark-02);\n    margin-bottom: 8px;\n    margin-left: 8px;\n    pointer-events: none;\n}\n\n.listElement {\n    padding: 8px;\n    font-family: var(--font-medium), sans-serif;\n    width: 100%;\n    border-radius: 8px;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BackButton_container__yqldg`,
	"hovered": `BackButton_hovered__j3wZj`,
	"text": `BackButton_text__3RGiu`,
	"listContainer": `BackButton_listContainer__fq6w3`,
	"listTitle": `BackButton_listTitle__7hEw7`,
	"listElement": `BackButton_listElement__PYBjy`
};
export default ___CSS_LOADER_EXPORT___;
